export default __webpack_public_path__ + "static/media/1.32a9aa2b.jpg";